import React from 'react'
import heart from './../assets/heart.png'
export const AboutText = () => {
    return (
        <div style={{ padding: '20px', fontWeight: 'bold', maxWidth: '768px', textAlign: 'left', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
            <p>Cosmic Moons is a concept created by two friends who love music, love to party, and want to share their passion. </p>
            <p>After participating in the biggest parties organized worldwide, we wanted to bring something different, a personal touch.  We have created a platform which will allow us to share our favorite music, meet new people, and build a community. You will be able to see theses artists perform at the events we organize all year round. They will be from everywhere, with different backgrounds and music genres.</p>
            <br/>
            <p>Cosmix sessions will also be uploaded regularly, as well as info on the artists we will be hosting so that everyone can follow and/or discover who we’re listening to. We are aiming to collaborate with anyone who we think can make our events that much more special and unique. Our greatest advantage is the network we have created by discovering and sharing our passion with people all over the world.</p>
            <br/>
            <p>We do not host any songs and have no rights to the songs posted. They are posted by the artists themselves on external platforms, we just relay them. For any complaint, do not hesitate to contact us.</p>
            <p>We do not read newsletters</p>
            <a href="mailto:contact@cosmic-moons.com">contact@cosmic-moons.com</a>
            <br /><br />

            <p>Website developped with <img src={heart} style={{ width: '16px', marginLeft: '5px', marginRight: '5px' }} /> by <a href="mailto:malik.benaboud@gmail.com">Malik</a></p>
            <br />
            <br /><br />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/AboutText.js